import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = accountId => [
  {
    id: 'goal_nav_item',
    icon: { name: 'menu.svg', isIcon: false },
    key: 'goal-dashboard',
    label: 'NAVBAR.PRIMARY.DASHBOARD',
    toState: frontendURL(`accounts/${accountId}/target-dashboard/goal`),
    toStateName: 'goal_dashboard',
    roles: ['administrator'],
    hasChildinMob: false,
  },
  {
    id: 'conversations',
    icon: { name: 'chats-circle.svg', isIcon: false },
    key: 'conversations',
    label: 'NAVBAR.PRIMARY.CHAT',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
    roles: ['administrator', 'agent'],
    hasChildinMob: false,
  },
  {
    id: 'contacts',
    icon: { name: 'agents.svg', isIcon: false },
    key: 'contacts',
    label: 'NAVBAR.PRIMARY.CONTACT',
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
    roles: ['administrator', 'agent'],
    hasChildinMob: false,
  },
  {
    id: 'campaigns',
    icon: { name: 'rule.svg', isIcon: false },
    key: 'campaigns',
    label: 'NAVBAR.PRIMARY.CAMPAIGN',
    toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
    toStateName: 'settings_account_campaigns',
    roles: ['administrator'],
    hasChildinMob: true,
  },
  {
    id: 'ai-nav',
    icon: { name: 'ai_bot.svg', isIcon: false },
    key: 'ai',
    label: 'NAVBAR.PRIMARY.AI',
    toState: frontendURL(`accounts/${accountId}/ai/flows`),
    toStateName: 'settings_account_campaigns',
    roles: ['administrator'],
    hasChildinMob: true,
  },
  {
    id: 'catalogues-nav',
    icon: { name: 'task-list-square-right.svg', isIcon: false },
    key: 'catalogues',
    label: 'NAVBAR.PRIMARY.ORDERS',
    toState: frontendURL(`accounts/${accountId}/catalog`),
    toStateName: 'catalogues_state',
    roles: ['administrator', 'agent'],
    hasChildinMob: true,
  },
  {
    id: 'calendars-nav',
    icon: { name: 'calendar.svg', isIcon: false },
    key: 'calendars',
    label: 'NAVBAR.PRIMARY.APPOINTMENT',
    toState: frontendURL(`accounts/${accountId}/calendar`),
    toStateName: 'calendars_state',
    roles: ['administrator', 'agent'],
    hasChildinMob: true,
  },
  {
    id: 'settings',
    icon: { name: 'configuration.svg', isIcon: false },
    key: 'settings',
    label: 'NAVBAR.PRIMARY.SETTINGS',
    toState: frontendURL(`accounts/${accountId}/settings`),
    toStateName: 'settings_home',
    roles: ['administrator', 'agent'],
    hasChildinMob: true,
  },
  {
    id: 'reports',
    icon: { name: 'dashboard.svg', isIcon: false },
    key: 'reports',
    label: 'NAVBAR.PRIMARY.REPORT',
    toState: frontendURL(`accounts/${accountId}/reports`),
    toStateName: 'settings_account_reports',
    roles: ['administrator'],
    hasChildinMob: true,
  },
  {
    icon: { name: 'question-mark.svg', isIcon: false },
    key: 'docs',
    label: 'NAVBAR.PRIMARY.DOCUMENT',
    toState: `https://peasy.ai/docs/peasysales`,
    toStateName: 'documentation',
    roles: ['administrator', 'agent'],
    hasChildinMob: false,
  },

  {
    id: 'credit-balance',
    icon: { name: 'creditcard-toolbox.svg', isIcon: false },
    key: 'credit_balance',
    label: 'NAVBAR.PRIMARY.CREDIT_BALANCE',
    toState: frontendURL(`accounts/${accountId}/credit/credit_balance`),
    toStateName: 'credit_home',
    roles: ['administrator'],
    hasChildinMob: true,
  },

  {
    icon: { name: 'pm-icon.png', isIcon: false },
    key: 'external-link',
    label: 'NAVBAR.PRIMARY.EXTERNAL_LINK',
    toState: 'pm-external',
    toStateName: 'external_link',
    roles: ['administrator'],
    hasChildinMob: false,
  },
];

export default primaryMenuItems;
